export const ROUTES = {
  home: '/home',
  login: '/login',
  landing: '/home/landing',
  myInsights: '/home/my-insights',
  kpiHub: '/home/kpi-hub',
  subjectArea: '/home/subject-area',
  dashboard: '/home/subject-area/dashboard',
  shouldLogin: '/should-login',
  notFound: '/not-found',
  landingNotConfigured: '/landing-not-found',
};

export const QUERY_PARAMS = {
  returnUrl: 'r',
} as const;
